export enum ContractPartner {
  Company = 'company',
  Person = 'person',
}
